import { NgClass, NgFor } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { IconModule } from '@spartacus/storefront';

@Component({
  selector: 'sd-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  imports: [NgFor, NgClass, IconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarRatingComponent implements OnChanges {
  icon = CUSTOM_ICON_TYPE.STAR;
  @Input() @HostBinding('attr.disabled') disabled = false;
  @Input() rating: number;

  @Output() changeRating = new EventEmitter<number>();

  private initialRating: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rating) {
      this.initialRating = changes.rating.currentValue || 0;
    }
  }

  setRate(value: number): void {
    if (this.disabled) {
      return;
    }
    this.rating = value;
  }

  @HostListener('mouseout')
  reset(): void {
    if (this.disabled) {
      return;
    }
    this.rating = this.initialRating;
  }

  saveRate(rating: number): void {
    if (this.disabled) {
      return;
    }
    this.setRate(rating);
    this.changeRating.emit(rating);
  }
}
